import ImgCoverComponent from './ImgCoverComponent';
export default ImgCoverComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/imgCover/index.ts
// module id = 1350
// module chunks = 0 1 2 3 5